import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { IPrice } from '@shared/jp/data/products';
import { MediaService } from '@studiobuki/web-core/lib/media';

@Component({
  selector: 'app-default[id][title][specs][photo]',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultComponent {
  @Input() id!: string;

  @Input() title!: string;

  /** supports html tags */
  @Input() subtitle!: string;

  @Input() specs!: { [key: string]: string };

  @Input() price: IPrice | undefined;

  @Input() photo!: string;

  @Input() discount: string | undefined;

  public Object = Object;

  get specsKeys() {
    return Object.keys(this.specs);
  }

  constructor(public media: MediaService) {}
}
